import React, { useState, useEffect, Fragment, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Visible } from '@leroy-merlin-br/backyard-react-ui'

import { useBodyScrollLock } from 'reactUtils/hooks/use-body-scroll-lock'

import { Icon } from 'lmcv/components/Icon'
import { useStep } from 'lmcv/hooks/use-step'
import { Actions as ActionsCoupon } from 'lmcv/redux/modules/coupon'

import {
  Wrapper,
  Inner,
  Content,
  Aside,
  ContentScroll
} from './components/Layout'
import { Picture } from './components/Picture'
import { Footer } from './components/Footer'
import { ClientsMobile } from './steps/ClientsMobile'
import { ClientsDesktop } from './steps/ClientsDesktop'
import { InitialDescription } from './steps/InitialDescription'
import { ConcludeMobile } from './steps/ConcludeMobile'
import { ConcludeDesktop } from './steps/ConcludeDesktop'
import * as S from './styled'

const ModalShare = ({
  id,
  title,
  description,
  rules,
  thumbnail,
  icon,
  buttonText,
  text,
  textFooter,
  isActive,
  isDisabled,
  onClose,
  isLoading,
  toggleModalError,
  customers,
  hasClients,
  price
}) => {
  const [customerSelected, setCustomer] = useState(null)

  const [prev, next, step] = useStep(1)
  const dispatch = useDispatch()

  const scrollElement = useRef()

  useBodyScrollLock(scrollElement)

  const onSubmit = () => {
    dispatch(ActionsCoupon.share(id, customerSelected.customer.id, onClose))
  }

  useEffect(() => {
    if (step !== 3) {
      setCustomer(null)
    }
  }, [step])

  const renderFooter = () => (
    <Footer
      price={price}
      text={text}
      buttonText={buttonText}
      textFooter={textFooter}
      isActive={isActive}
      isLoading={isLoading}
      isDisabled={isDisabled}
      currentStep={step}
      next={next}
      prev={prev}
      customerSelected={customerSelected}
      onSubmit={onSubmit}
      toggleModalError={toggleModalError}
      hasClients={hasClients}
    />
  )

  const renderPicture = () => (
    <Picture src={thumbnail} alt={title} isActive={isActive} icon={icon} />
  )

  return (
    <Fragment>
      <Wrapper isActive={isActive}>
        <Visible untilKilo kilo mega>
          <ConcludeMobile
            price={price}
            currentStep={step}
            customerSelected={customerSelected}
            onClick={onSubmit}
            onClose={prev}
          />
        </Visible>

        <Visible untilKilo kilo mega>
          <ClientsMobile
            currentStep={step}
            customers={customers}
            onSelectCustomer={setCustomer}
            customerSelected={customerSelected}
            onClose={prev}
            onClick={next}
          />
        </Visible>

        <S.ModalClose onClick={onClose} isActive={isActive}>
          <Icon name="close_tiny" />
        </S.ModalClose>

        <S.ModalCloseText onClick={onClose}>
          <span>Fechar</span> <Icon name="close_tiny" />
        </S.ModalCloseText>

        <Inner>
          <ContentScroll ref={scrollElement}>
            <Visible untilKilo kilo mega>
              <Aside>{renderPicture()}</Aside>
            </Visible>

            <Content>
              <InitialDescription
                currentStep={step}
                title={title}
                description={description}
                rules={rules}
              />

              <Visible giga tera>
                <ClientsDesktop
                  currentStep={step}
                  customers={customers}
                  onSelectCustomer={setCustomer}
                />
              </Visible>

              <Visible giga tera>
                <ConcludeDesktop
                  price={price}
                  currentStep={step}
                  customerSelected={customerSelected}
                  onClick={onSubmit}
                />
              </Visible>
            </Content>
          </ContentScroll>

          <Visible giga tera>
            <Aside>
              {renderPicture()}

              {renderFooter()}
            </Aside>
          </Visible>
        </Inner>

        <Visible untilKilo kilo mega>
          {renderFooter()}
        </Visible>
      </Wrapper>
    </Fragment>
  )
}

export default ModalShare
